import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router';
import { AppProvider } from './context/AppContext';
import Home from './components/Home';
import Dialog from './components/Dialog';
import Login from './components/Login';
import Disclaimer from './components/Disclaimer';
import ResetPassword from './components/ResetPassword';
import useAuth from './hooks/useAuth';
import './App.css';

function App() {
  const navigate = useNavigate();

  // Check for JWT on initial load
  useEffect(() => {
    document.title = 'Documents Chatbot';
  }, [navigate]);

  useAuth(); // Handle authentication and redirects

  return (
    <AppProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/home" element={<Home />} />
          <Route path="/dialog" element={<Dialog />} />
        </Routes>
      </div>
    </AppProvider>
  );
}

export default App;
